import { render, staticRenderFns } from "./returnPayFeeManageList.vue?vue&type=template&id=32745a71&scoped=true"
import script from "./returnPayFeeManageList.vue?vue&type=script&lang=js"
export * from "./returnPayFeeManageList.vue?vue&type=script&lang=js"
import style0 from "./returnPayFeeManageList.vue?vue&type=style&index=0&id=32745a71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32745a71",
  null
  
)

export default component.exports